module.exports = __webpack_public_path__ + "video/1500_KMSAT45_2022_YRIntroduction.41bfdea3.vtt";